import { AccordionIcon, Flex, Heading } from '@chakra-ui/react'
import JGoogleIcon from '../../JGoogleIcon/JGoogleIcon'
import useSidebarV2 from '../useSidebarV2'
import sidebarV2Store from '../../../stores/sidebar-v2.store'
import { ParentMenuProps } from '../../../types/sidebar-v2.type'

interface SubMenuLabelProps {
  parentMenu: ParentMenuProps
  isActive: boolean
}

export default function SubMenuLabel(props: SubMenuLabelProps) {
  const { isActive, parentMenu } = props

  const { textColor, searchBarBackgroundColor } = useSidebarV2()
  const { reveal } = sidebarV2Store()

  return (
    <Flex 
      padding='4px' 
      alignItems='center' 
      gap='4px'
      borderRadius='8px'
      width='100%'
      backgroundColor={isActive ? searchBarBackgroundColor : 'unset'}
    >
      <JGoogleIcon
        name={parentMenu.icon}
        fontSize='24px'
        color={textColor}
        marginX={reveal ? 'unset' : 'auto'}
      />
      <Heading 
        size='chakra_label_large' 
        color={textColor} 
        display={reveal ? 'block' : 'none'}
      >{parentMenu.label}</Heading>
      <AccordionIcon 
        marginLeft='auto' 
        color={textColor} 
        display={reveal ? 'block' : 'none'} 
      />
    </Flex>
  )
}
